import { gameListData } from '@/views/system/ranking/typings';

export interface rankingListProps {
  total?: number;
  page: number;
  list: gameListData[];
  hasMore: boolean;
  loading: boolean;
  id: number;
  cTime: number;
  index: number;
  status: boolean;
}

export const rankingList: rankingListProps[] = [
  { id: 4, page: 1, list: [], loading: true, hasMore: true, cTime: 0, index: 0, status: false },
  { id: 1, page: 1, list: [], loading: true, hasMore: true, cTime: 0, index: 1, status: false },
  { id: 2, page: 1, list: [], loading: true, hasMore: true, cTime: 0, index: 2, status: false }
];
export const rankingBeList: rankingListProps[] = [
  { id: 4, page: 1, list: [], loading: true, hasMore: true, cTime: 0, index: 0, status: false },
  { id: 1, page: 1, list: [], loading: true, hasMore: true, cTime: 0, index: 1, status: false },
  { id: 2, page: 1, list: [], loading: true, hasMore: true, cTime: 0, index: 2, status: false }
];
